import { FieldsRenderer } from '@neo/blocks/forms/fields-renderer'
import type { GenericFormType } from '@neo/blocks/forms/types'
import { cn } from '@neo/lib/utils'
import { Button } from '@neo/primitives/button'
import { Tooltip } from '@neo/primitives/tooltip'
import { PlusIcon, Trash2 } from 'lucide-react'
import { actionInitialState } from 'v2/pages/flow/config/nodes.config'
import z from 'zod'
import type { AiActionNodeData } from '../../../types'
import { ActionsForm } from './action-form-v2'

export const Actions = ({
  form,
  nodeVars = [],
}: {
  form: GenericFormType<AiActionNodeData['config']>
  nodeVars?: string[]
}) => {
  const isMultipleActions = form.state.values.actions.length > 1

  return (
    <div className={cn('w-full max-w-2xl mx-auto', isMultipleActions && 'flex flex-col gap-4')}>
      <FieldsRenderer
        form={form}
        fields={[
          {
            name: 'actions_single',
            type: 'basic',
            component: () =>
              isMultipleActions ? null : <ActionsForm form={form} nodeVars={nodeVars} />,
          },
          {
            name: 'actions',
            visible: isMultipleActions,
            type: 'array',
            defaultNewValue: (_, field) => actionInitialState(field.state.value.length),
            className: 'relative',
            removeItemButton: (
              <Tooltip content="Remove action">
                <Button
                  variant="ghostDestructive"
                  className="absolute right-8 top-2"
                  type="button"
                  size="iconSm"
                  aria-label="Remove action"
                >
                  <Trash2 size={16} />
                </Button>
              </Tooltip>
            ),
            addItemButton: (props) => (
              <div>
                <Button
                  className="flex items-center mt-4 form-button"
                  variant="ghost"
                  type="button"
                  disabled
                  {...props}
                >
                  <PlusIcon className="h-4 w-4 mr-2" />
                  Define Actions
                </Button>
              </div>
            ),
            subFields: [
              {
                name: '',
                type: 'sub-item',
                component: (props) => (
                  <ActionsForm
                    form={props.form}
                    arrayIndex={props.arrayIndex}
                    nodeVars={nodeVars}
                  />
                ),
                zodValidation: z.any(),
                eventDataExtractor: (data) => data as Record<string, unknown>,
              },
            ],
          },
        ]}
      />
    </div>
  )
}
